"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Square = exports.Divider = exports.ContainerMemoized = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactI18next = require("react-i18next");
var _handlers = require("../../../../../../helpers/handlers");
var _fontSizeController = require("../../../../../../services/fontSizeController");
var _useRefPromise = require("../../../../../../services/useRefPromise");
var _Button = _interopRequireWildcard(require("../../../../../ui/Button"));
var _Tooltip = _interopRequireWildcard(require("../../../../../ui/Tooltip"));
var _CircleLoader = _interopRequireDefault(require("../../../../../ui/CircleLoader"));
var _RenderWhen = _interopRequireDefault(require("../../../../../RenderWhen"));
var _styles = _interopRequireDefault(require("./styles"));
var _arrowOutward = _interopRequireDefault(require("./arrow-outward.svg"));
var _excluded = ["logo", "name"],
  _excluded2 = ["category"],
  _excluded3 = ["name"];
var _templateObject;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var Container = function Container(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.pricesContainer
  }, children);
};
var StyledPrice = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    color: ", ";\n"])), function (props) {
  return props.theme.primaryColor;
});
var Square = exports.Square = function Square(_ref2) {
  var arrowLink = _ref2.arrowLink,
    children = _ref2.children,
    className = _ref2.className,
    _ref2$loading = _ref2.loading,
    loading = _ref2$loading === void 0 ? false : _ref2$loading,
    price = _ref2.price,
    onClick = _ref2.onClick;
  var _useTranslation = (0, _reactI18next.useTranslation)('RESULTS'),
    t = _useTranslation.t;
  var textRefPromise = (0, _useRefPromise.useRefPromise)(null);
  var wrapperRefPromise = (0, _useRefPromise.useRefPromise)(null);
  var _useFontSizeControlle = (0, _fontSizeController.useFontSizeController)(price ? textRefPromise : null, price ? wrapperRefPromise : null),
    fontSize = _useFontSizeControlle.fontSize;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.squareWrapper,
    ref: wrapperRefPromise.setRef
  }, arrowLink && /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    content: t('GO_TO_OPERATOR_WEBSITE'),
    placement: _Tooltip.PLACEMENTS.TOP,
    trigger: [_Tooltip.TRIGGERS.HOVER]
  }, /*#__PURE__*/_react.default.createElement("a", {
    "aria-label": "Link",
    className: _styles.default.pricesSquareIcon,
    dangerouslySetInnerHTML: {
      __html: _arrowOutward.default
    },
    href: arrowLink.href,
    target: "_blank",
    rel: "noreferrer",
    onClick: (0, _handlers.handleWith)(_handlers.stop, arrowLink.onClick),
    onMouseUp: (0, _handlers.handleWith)(_handlers.stop, arrowLink.onMouseUp)
  })), /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    content: t('FILTER'),
    placement: _Tooltip.PLACEMENTS.TOP,
    trigger: [_Tooltip.TRIGGERS.HOVER]
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    width: _Button.WIDTHS.FLUID,
    height: _Button.HEIGHTS.FLUID,
    className: (0, _classnames2.default)(_styles.default.pricesSquare, className, _defineProperty({}, _styles.default.hoverable, !!arrowLink)),
    contentClassName: _styles.default.pricesSquareInner,
    onClick: onClick
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: _styles.default.pricesSquareTop
  }, children), /*#__PURE__*/_react.default.createElement(_RenderWhen.default, {
    isTrue: true
  }, /*#__PURE__*/_react.default.createElement(_RenderWhen.default.If, {
    isTrue: loading
  }, /*#__PURE__*/_react.default.createElement(_CircleLoader.default, null)), /*#__PURE__*/_react.default.createElement(_RenderWhen.default, {
    isTrue: true
  }, /*#__PURE__*/_react.default.createElement(_RenderWhen.default.If, {
    isTrue: !!price
  }, /*#__PURE__*/_react.default.createElement(StyledPrice, {
    className: _styles.default.pricesItemValue,
    ref: textRefPromise.setRef,
    style: fontSize ? {
      fontSize: fontSize
    } : undefined
  }, price)), /*#__PURE__*/_react.default.createElement(_RenderWhen.default.If, {
    isTrue: true
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames2.default)(_styles.default.pricesItemValue, _styles.default['pricesItemValue--empty-price'])
  }, t('PRICE_ANALYTICS_FILTER_EMPTY_STATE'))))))));
};
Square.propTypes = {
  arrowLink: _propTypes.default.shape({
    href: _propTypes.default.string.isRequired,
    onClick: _propTypes.default.func,
    onMouseUp: _propTypes.default.func
  }),
  children: _propTypes.default.node,
  loading: _propTypes.default.bool,
  price: _propTypes.default.string,
  onClick: _propTypes.default.func
};
var SquareAsOperator = function SquareAsOperator(_ref3) {
  var logo = _ref3.logo,
    name = _ref3.name,
    props = _objectWithoutProperties(_ref3, _excluded);
  return /*#__PURE__*/_react.default.createElement(Square, props, /*#__PURE__*/_react.default.createElement("img", {
    src: logo,
    alt: name
  }));
};
SquareAsOperator.propTypes = {
  logo: _propTypes.default.string.isRequired,
  name: _propTypes.default.string.isRequired
};
Square.Operator = (0, _react.memo)(SquareAsOperator);
var SquareAsCategory = function SquareAsCategory(_ref4) {
  var category = _ref4.category,
    props = _objectWithoutProperties(_ref4, _excluded2);
  return /*#__PURE__*/_react.default.createElement(Square, _extends({
    className: _styles.default.starSquare
  }, props), category ? /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.pricesSquareStar
  }, "".concat(category, "*")) : null);
};
SquareAsCategory.propTypes = {
  category: _propTypes.default.string
};
Square.Caregory = (0, _react.memo)(SquareAsCategory);
var SquareAsDeparture = function SquareAsDeparture(_ref5) {
  var name = _ref5.name,
    props = _objectWithoutProperties(_ref5, _excluded3);
  return /*#__PURE__*/_react.default.createElement(Square, _extends({
    className: _styles.default.departureSquare
  }, props), name ? /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.pricesSquareTitle
  }, name) : null);
};
SquareAsDeparture.propTypes = {
  name: _propTypes.default.string
};
Square.Departure = (0, _react.memo)(SquareAsDeparture);
var Divider = exports.Divider = function Divider() {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.pricesSeparator
  });
};
var ContainerMemoized = exports.ContainerMemoized = (0, _react.memo)(Container);